import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var BaseBadge = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  border: ", ";\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-size: ", "px;\n  padding-top: 2px;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  border: ", ";\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-size: ", "px;\n  padding-top: 2px;\n"])), function (props) {
  var _a, _b, _c, _d;

  return props.borderColor && props.borderColor !== 'none' ? "1px solid ".concat(props.borderColor) : props.background === ((_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.white) ? "1px solid ".concat((_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.palette) === null || _d === void 0 ? void 0 : _d.light) : 'none';
}, function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.background;
}, function (props) {
  return props.color;
}, function (props) {
  var _a, _b, _c;

  return (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.size) === null || _c === void 0 ? void 0 : _c.s2;
});
var templateObject_1;
export { BaseBadge };